(function (footer) {
    function click(e) {
        e.preventDefault();
        if (e.target.classList.contains('active-footer')) {
            window.location.href = e.currentTarget;
        }
    }

    footer.querySelector('#botao-conta-digital1').addEventListener('click', click);
    footer.querySelector('#botao-sobre-banqi').addEventListener('click', click);
    footer.querySelector('#botao-duvidas').addEventListener('click', click);
    if (footer.querySelector('#botao-blog')) {
        footer.querySelector('#botao-blog').addEventListener('click', click);
    }

    var coll = document.querySelectorAll("footer .collapsible");

    coll.forEach(function (el, j, arr) {
        el.addEventListener("click", function () {
            var other = document.querySelectorAll(".active-footer");
            other.forEach(function (el, j, arr) {
                togleActiveElement(el, 'active-footer');
            });

            togleActiveElement(this, 'active-footer');
        });
    });
}(footer));

function togleActiveElement(el, cls) {
    el.classList.toggle(cls);
}
